var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 4.5,
    r: 2.5,
    fill: "#FF3A3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78906 13.5947C8.78906 10.1629 11.5711 7.38086 15.0029 7.38086V7.38086C18.4348 7.38086 21.2168 10.1629 21.2168 13.5947V20.0843H8.78906V13.5947Z",
    stroke: "currentColor",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.3804L15 5.45215",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29297 20.084H22.7091",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8594 20.084H18.1386V20.343C18.1386 22.077 16.7329 23.4826 14.999 23.4826V23.4826C13.265 23.4826 11.8594 22.077 11.8594 20.343V20.084Z",
    stroke: "currentColor",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmDot);
export default __webpack_public_path__ + "static/media/alarm-dot.810e90a881b08f69a00d57e0f1bfa87f.svg";
export { ForwardRef as ReactComponent };